import * as React from 'react'

import { Box, Button, Text } from '@factorialco/deprecated-design-system'
import {
  CompetenciesDataCollectionDocument,
  CompetenciesDeleteCompetencyDocument,
} from 'generated/resources/graphql'

import Modal from 'modules/core/components/Modal'
import TextField from 'modules/core/components/TextField'
import { useMutation } from 'modules/core/hooks/useMutation'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

export const DeleteCompetencyModal: React.FC<{
  competencyId: number
  competencyName: string
  onClose: () => void
  onSuccess?: () => void
}> = ({ competencyId, competencyName, onClose, onSuccess }) => {
  const [inputName, setInputName] = React.useState<string>('')
  const inputIsOk = inputName.trim() === competencyName?.trim()

  const [deleteCompetencyMutation, { loading: deletingCompetency }] = useMutation(
    CompetenciesDeleteCompetencyDocument,
    {
      extractorFn: (data) => data.competenciesMutations.deleteCompetenciesCompetency,
      update(cache) {
        cache.evict({
          id: cache.identify({ id: competencyId, __typename: 'CompetenciesCompetency' }),
        })
      },
      refetchQueries: [CompetenciesDataCollectionDocument],
    }
  )

  const deleteCompetency = async () => {
    const response = await deleteCompetencyMutation({
      variables: {
        id: competencyId,
      },
    })

    const handled = handleResult(response, () => undefined)
    if (handled.success) {
      app.setFlash({
        type: 'correct',
        message: i18n.t('common.removed_successfully'),
      })

      onClose()
      onSuccess?.()
      return handled
    }
  }

  return (
    <Modal
      title={i18n.t('competencies_v3.delete_competency.title')}
      description={i18n.t('competencies_v3.delete_competency.description')}
      footer={
        <>
          <Button type="secondary" onClick={onClose}>
            {i18n.t('common.cancel')}
          </Button>
          <Button disabled={deletingCompetency || !inputIsOk} submit>
            {i18n.t('common.delete')}
          </Button>
        </>
      }
      illustration="delete-cross"
      onClose={onClose}
      onSubmit={deleteCompetency}
    >
      <Box flexDirection="column" gap="s8">
        <Text.Normal whiteSpace="breakSpaces">
          {i18n.t('competencies_v3.delete_competency.deletion_input', {
            name: competencyName,
          })}
        </Text.Normal>
        <TextField onChange={setInputName} value={inputName} />
      </Box>
    </Modal>
  )
}
